/**
 * Safely parses JSON string without throwing.
 * Returns null if the value is null or parsing fails.
 */
export function safeJSONParse(value: string | null): unknown {
  if (value === null) {
    return null
  }
  try {
    return JSON.parse(value)
  } catch (e) {
    console.error('Failed to parse JSON from localStorage', e)
    return null
  }
}
